import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ErrorMessageContainer = styled.div<{show:boolean}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 20px;
  background: rgba(233, 164, 38, 0.8);
  padding: 8px;
  margin: 16px 0;
  opacity: ${({show}) => show ? 1 : 0};
  transition: opacity 2s ease-in-out;
`

export const ErrorMessageIcon = styled(FontAwesomeIcon)`
  color: #fff;
`

export const ErrorMessageText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.8em;
  text-align: center;
  margin: 0 16px;
`
